// test2658
(2658 && 0);
